export const closeNotification = () => ({
	type: "closeNotification",
	payload: "",
});
export const openNotification = (message) => ({
	type: "openNotification",
	payload: message,
});
